// 百源拦截器
import type { AxiosResponse, InternalAxiosRequestConfig, AxiosHeaders } from 'axios';
import type { HttpResponse } from '@/apis/request';
import { useSettingsStore, useUserStore, getEmpCode, type BaspHttpResponse } from '@/layouts/sfapp';

const isBaspUrl = (url: string | undefined) => {
  return url?.indexOf('/dev-basp-user/') !== -1;
};

export default {
  // 请求拦截器
  request: [
    (config: InternalAxiosRequestConfig) => {
      if (!config.headers) {
        // eslint-disable-next-line no-param-reassign
        config.headers = {} as AxiosHeaders;
      }

      const {
        settings: { menu, basp },
      } = useSettingsStore();
      if (menu.baseOn === 'basp') {
        const empCode = getEmpCode();
        if (empCode) {
          config.headers['userId'] = empCode;
        }

        const userStore = useUserStore();
        config.headers['systemkey'] = basp?.baspSystemKey || null;
        config.headers['gw-bdus-rid'] = userStore.roleId || null;
      }

      return config;
    },
  ],
  // 响应拦截器
  response: [
    (response: AxiosResponse<HttpResponse>) => {
      if (isBaspUrl(response.config.url)) {
        // 响应拦截，转换百源响应格式
        const data = response.data as unknown as BaspHttpResponse;
        response.data = {
          success: data.succ === 'ok',
          obj: data.result,
          errorMessage: data.msg,
          errorCode: '',
        };
      }
      return response;
    },
  ],
};
